document.addEventListener("DOMContentLoaded", function () {

    const filters = document.querySelectorAll(".filter-item");
    const cards = document.querySelectorAll(".product-card");
    const count = document.getElementById("product-count");

    // =========================
    // Update Product Count
    // =========================
    function updateCount() {
        let visible = 0;

        cards.forEach((card) => {
            if (card.style.display !== "none") {
                visible++;
            }
        });

        count.innerHTML = visible + " Products";
    }

    updateCount();

    // =========================
    // Filter Products
    // =========================
    filters.forEach((filter) => {

        filter.addEventListener("click", function () {

            filters.forEach((item) => {
                item.classList.remove("active");
            });

            this.classList.add("active");

            const handle = this.dataset.filter;

            cards.forEach((card) => {

                if (card.dataset.collection === handle) {
                    card.style.display = "block";
                } else {
                    card.style.display = "none";
                }

            });

            updateCount();

        });

    });

    // =========================
    // Clear Filters
    // =========================
    document.querySelector(".clear-filter").addEventListener("click", function () {

        filters.forEach((filter) => {
            filter.classList.remove("active");
        });

        cards.forEach((card) => {
            card.style.display = "block";
        });

        updateCount();

    });


    // =========================
// Pre-select filter from URL (?collection=handle)
// =========================
const urlParams = new URLSearchParams(window.location.search);
const preselect = urlParams.get("collection");

if (preselect) {
    const match = document.querySelector(
        '.filter-item[data-filter="' + decodeURIComponent(preselect) + '"]'
    );

    if (match) {
        match.click();
    }
}

    // =========================
    // Add To Cart
    // =========================
    document.querySelectorAll(".add-cart").forEach((button) => {

        button.addEventListener("click", function () {

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: this.dataset.id,
                    quantity: 1
                })
            })
            .then((response) => response.json())
            .then(() => {
                alert("Added To Cart");
            });

        });

    });

});